/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum TerminalEventStatusCodeApiModel {
  TerminalSignInAwaiting = 'terminal-sign-in-awaiting',

  StaffSignInAwaiting = 'staff-sign-in-awaiting',

  CustomerAwaiting = 'customer-awaiting',

  CustomerProcessing = 'customer-processing',

  RefuelingStarted = 'refueling-started',

  RefuelingFinished = 'refueling-finished',

  TerminalSettingsProcessing = 'terminal-settings-processing',

  CustomerTapSplashscreen = 'customer-tap-splashscreen',

  PaymentProcess = 'payment-process'
}
